import { render, staticRenderFns } from "./FormDocumentacion_Persona.vue?vue&type=template&id=5ec83632"
import script from "./FormDocumentacion_Persona.vue?vue&type=script&lang=js"
export * from "./FormDocumentacion_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec83632')) {
      api.createRecord('5ec83632', component.options)
    } else {
      api.reload('5ec83632', component.options)
    }
    module.hot.accept("./FormDocumentacion_Persona.vue?vue&type=template&id=5ec83632", function () {
      api.rerender('5ec83632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Documentacion/FormDocumentacion_Persona.vue"
export default component.exports